import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { createNumberCell } from 'components/table/DataTableUtil';

export function CurrencyCell({ value, className = '' }: { value: number; className?: string }) {
  const { currencyCode } = useContext(TenantConfigContext);
  const intl = useIntl();
  return createNumberCell(intl.formatNumber(value, { style: 'currency', currency: currencyCode }), className);
}
